var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-interface-symbol",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34__4_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139619",
    "data-name": "Group 139619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34159",
    "data-name": "Path 34159",
    d: "M21.8,20.8l-5.68-5.589a8.984,8.984,0,0,0,2.4-6.105A9.184,9.184,0,0,0,9.262,0,9.183,9.183,0,0,0,.006,9.109a9.183,9.183,0,0,0,9.256,9.109,9.309,9.309,0,0,0,5.826-2.034l5.7,5.611a.72.72,0,0,0,1.007,0A.693.693,0,0,0,21.8,20.8ZM9.262,16.816A7.77,7.77,0,0,1,1.43,9.109,7.77,7.77,0,0,1,9.262,1.4a7.77,7.77,0,0,1,7.832,7.707A7.77,7.77,0,0,1,9.262,16.816Z",
    transform: "translate(-0.006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6f83a67088874fc12c4f1d832d3c5e63.svg";
export { ForwardRef as ReactComponent };